import { render, staticRenderFns } from "./wellcome.vue?vue&type=template&id=62183522&scoped=true"
import script from "./wellcome.vue?vue&type=script&lang=js"
export * from "./wellcome.vue?vue&type=script&lang=js"
import style0 from "./wellcome.vue?vue&type=style&index=0&id=62183522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62183522",
  null
  
)

export default component.exports